// Auto-generated per-query builders for VersioningBranch
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { VersioningBranchReadAPI, VersioningBranchWriteAPI, VersioningBranchReadAPISchema, VersioningBranchWriteAPISchema } from '../types/versioningbranch';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, OfIsland } from '../../relationships/relationship';

import { SecurityScope } from './securityscope';
import { ScopedNode } from './scopednode';



// Field names for order_by on VersioningBranch
type VersioningBranchFields = "branch" | "-branch";



// Builder chain for query: versioning-branches

export interface VersioningBranchesBuilder_0 {
  filter(conditions: { island_id: string }): VersioningBranchesBuilder_1;
}

export interface VersioningBranchesBuilder_1 {
  orderBy(field?: VersioningBranchFields): VersioningBranchesBuilder_1;
}

export interface VersioningBranchesBuilder_1 {
  limit(value?: number): VersioningBranchesBuilder_1;
  all(): Promise<VersioningBranch[]>;
  first(): Promise<VersioningBranch | null>;
  get(): Promise<VersioningBranch[]>;
  execute(): Promise<VersioningBranch[]>;
}


// Union of all query entry points
export type VersioningBranchQueryBuilder = VersioningBranchesBuilder_0;

// Available query names for .setQuery()
export type VersioningBranchQueryNames = "versioning-branches";

// Type narrowing for .setQuery()
export type VersioningBranchBuilderForQuery<Q extends VersioningBranchQueryNames> =
  Q extends "versioning-branches" ? VersioningBranchesBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type VersioningBranchInstanceQueryResult<Q extends VersioningBranchQueryNames> =
  Q extends "versioning-branches" ? VersioningBranchesBuilder_0
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  'filter|order_by|limit': 'versioning-branches',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends VersioningBranchQueryNames>(queryName: Q): VersioningBranchBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface VersioningBranch extends Partial<VersioningBranchReadAPI> {}
export class VersioningBranch extends NeoNodeBase<VersioningBranchReadAPI, VersioningBranchWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "VersioningBranch";
  static readonly readSchema = VersioningBranchReadAPISchema;
  static readonly writeSchema = VersioningBranchWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    island_root: { target: "ScopedNode", cardinality: "one", isParent: false, relClass: "OfIsland", direction: "out" },
  };

  protected get modelName(): string {
    return 'VersioningBranch';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return VersioningBranch.label;
  }


  constructor(data: Partial<VersioningBranchWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: VersioningBranchReadAPI, loadContext?: Record<string, any>): VersioningBranch {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { security_scope, island_root, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = VersioningBranchReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, security_scope: security_scope, island_root: island_root };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return VersioningBranch.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'island_root', 'ScopedNode', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new VersioningBranch(processed as any);

    return instance;
  }

  static filter(conditions: { island_id: string }): VersioningBranchesBuilder_0;

  static filter(conditions: Record<string, any>): VersioningBranchQueryBuilder;

  static filter(conditions: Record<string, any>): VersioningBranchQueryBuilder {
    return new QueryBuilderImpl('VersioningBranch').filter(conditions) as any;
  }

  static all(): VersioningBranchQueryBuilder {
    return new QueryBuilderImpl('VersioningBranch') as any;
  }

  static async first(): Promise<VersioningBranch | null> {
    const results = await new QueryBuilderImpl('VersioningBranch').execute();
    return results[0] || null;
  }


  static setQuery<Q extends VersioningBranchQueryNames>(queryName: Q): VersioningBranchBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('VersioningBranch');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends VersioningBranchQueryNames>(queryName: Q): VersioningBranchInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = VersioningBranch.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'island_root' - Python ORM style (cached)
  get island_root(): RelationshipManager<this, ScopedNode> {
    return this.getOrCreateRelationshipManager('island_root', () => {
      return new RelationshipManager(this, 'island_root', 'one', OfIsland as typeof Relationship);
    });
  }

}
